/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn Diagram Maker (2 & 3 Sets, Free) — Toolverse`)
};

const es_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creador de Diagramas de Venn (2 y 3 Conjuntos, Gratis) — Toolverse`)
};

const de_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn-Diagramm-Generator (2 & 3 Mengen, Kostenlos) — Toolverse`)
};

const nl_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venn-diagram Maker (2 & 3 sets, Gratis) — Toolverse`)
};

const fr_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créateur de diagramme de Venn (2 et 3 ensembles, gratuit) — Toolverse`)
};

const it_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creatore di Diagrammi di Venn (2 e 3 Insiemi, Gratis) — Toolverse`)
};

const pt_br2_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Diagrama de Venn (2 e 3 Conjuntos, Grátis) — Toolverse`)
};

const pt_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criador de Diagramas de Venn (2 e 3 Conjuntos, Grátis) — Toolverse`)
};

const ja_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベン図作成ツール(2集合・3集合対応・無料) — Toolverse`)
};

const zh_venn_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`维恩图生成器（2 组和 3 组，免费）— Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_meta_title", locale)
	if (locale === "en") return en_venn_meta_title(inputs)
	if (locale === "es") return es_venn_meta_title(inputs)
	if (locale === "de") return de_venn_meta_title(inputs)
	if (locale === "nl") return nl_venn_meta_title(inputs)
	if (locale === "fr") return fr_venn_meta_title(inputs)
	if (locale === "it") return it_venn_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_venn_meta_title(inputs)
	if (locale === "pt") return pt_venn_meta_title(inputs)
	if (locale === "ja") return ja_venn_meta_title(inputs)
	return zh_venn_meta_title(inputs)
};